import { Button, Card, CardBody, Col, Form, Row } from "reactstrap";
import { AcHolderName, AccountNumber, EnterMobileNumber, ICFCCode, NetBankings, OtherDetails, Submit } from "../../../../constants";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import { EmiBankSelect } from "../../../../data/applications/ECommerce";
import FormInput from "./common/FormInput";
import SelectInput from "./common/SelectInput";

// This component is used to create a form for Net Banking payment details, with fields for account holder name, account number, bank selection, ICFC code, mobile number, and other details.
const NetBanking = () => {
  return (
    <Col xxl="4" lg="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={NetBankings} headClass="pb-0" />
        <CardBody>
          <Form className="theme-form" onSubmit={(e) => e.preventDefault()}>
            <Row>
              <FormInput type="text" placeholder={AcHolderName} formClass="col-12" />
              <FormInput type="text" placeholder={AccountNumber} formClass="col-12" />
              <SelectInput size={1} data={EmiBankSelect} selectClass="col-6 p-r-0" />
              <FormInput type="text" placeholder={ICFCCode} formClass="col-6" />
              <FormInput type="number" placeholder={EnterMobileNumber} formClass="col-12" />
              <FormInput type="text" placeholder={OtherDetails} formClass="col-12" />
              <Col xs="12">
                <Button color="primary">{Submit}</Button>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default NetBanking;
